import React, { useState } from 'react';
import Button from '../Button/Button';
import CardToogle from '../Toogle/CardToogle';
import { getEventTerrainSvgIcon } from '../../utilities';
import { theme } from '../../theme';
import styled from 'styled-components';
import Typography from '../Typography';
import Modal from './Modal';
import { useTranslation } from 'react-i18next';
import { TERRAIN_TYPES, TERRAIN_ALL } from '../../constants/eventTypes';

// Update the component props to match other modals
const CreateEventTerrainModal = ({ terrain, onSave, onClose }) => {
  const { t } = useTranslation(['createEvent', 'eventCategories']);
  const [selectedTerrain, setSelectedTerrain] = useState(
    Array.isArray(terrain) ? terrain : []
  );

  const handleSelect = (terrain) => {
    // Si es "all", seleccionamos road y offroad
    if (terrain === TERRAIN_ALL) {
      const roadAndOffroad = TERRAIN_TYPES.filter(type => type !== TERRAIN_ALL);
      setSelectedTerrain(roadAndOffroad);
    } else {
      // Toggle de selección
      setSelectedTerrain(prev => {
        const newValue = prev.includes(terrain)
          ? prev.filter(t => t !== terrain)
          : [...prev, terrain];
        return newValue;
      });
    }
  };

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title={t('createEventTerrainModal.title')}
      closeOnOverlayClick={false}
    >
      <ModalContent>
        <Typography as="p" $variant="body-1-medium" color={theme.colors.defaultWeak}>
          {t('createEventTerrainModal.description')}
        </Typography>
        <TerrainList>
          {TERRAIN_TYPES.map(terrainType => (
            <CardToogle
              key={terrainType}
              category={t(`eventCategories:terrain.${terrainType}`)}
              isActive={
                terrainType === TERRAIN_ALL
                  ? selectedTerrain.includes('road') && selectedTerrain.includes('offroad')
                  : selectedTerrain.includes(terrainType)
              }
              onClick={() => handleSelect(terrainType)}
              icon={getEventTerrainSvgIcon(
                terrainType,
                (terrainType === TERRAIN_ALL
                  ? selectedTerrain.includes('road') && selectedTerrain.includes('offroad')
                  : selectedTerrain.includes(terrainType)
                ) ? theme.colors.brandMain : theme.colors.defaultSubtle
              )}
            />
          ))}
        </TerrainList>
      </ModalContent>
      <FormActions>
        <Button size="medium" onClick={() => { onSave?.(selectedTerrain); onClose(); }}>
          {t('createEventTerrainModal.save')}
        </Button>
      </FormActions>
    </Modal>
  );
};

export default CreateEventTerrainModal;

const ModalContent = styled.div`
  align-items: flex-start;
  background-color: ${({ theme }) => theme.fill.defaultMain};
  border-radius: ${({ theme }) => theme.radius.sm};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.md};
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 100%;
  }
`;


const TerrainList = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.sizing.xs} ${({ theme }) => theme.sizing.xs};
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
`;

const FormActions = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border.defaultWeak};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  text-align: center;
  width: 100%;
`;
